import React, { Component } from "react";
import "./events.css";

import EventCard from "../components/eventCard";
import legacyBricks from "../images/legacyBricks.jpg";
import bookSale1 from "../images/bookSale1.jpg";
import bookSale2 from "../gallery/gallery47.png";
import jeans from "../images/jeans.jpg"
import legacyBrickForm from "../files/legacy_brick_form.docx";
import diningForDollars from "../files/diningForDollars.jpg"
import downloadIcon from "../icons/downloadIcon.png"
import { BrowserRouter as Router, Link } from "react-router-dom";
 const legacyBrickInfo="For $100 you can buy a two line, custom engraved Legacy Brick. Legcay Bricks will be used in the landscaping around the building. Click below to download the form and follow the instructions to purchase."
const bookSaleInfo= "There's another Book Sale coming soon!  3,000+ books to peruse. Old and New!  Something for everyone, every age, action packed to cook book.";
const eventCard1 = (
  <EventCard
    eventImage={legacyBricks}
    title={"Legacy Brick Fundraiser"}
    information={legacyBrickInfo}
    startDate={"Now"}
    endDate={"While Supplies Last"}
    width={"25%"}
    style={{ minWidth: "300px" }}
    height={"auto"}
    endTime={"7"}
    startTime={"24"}
    content={
      <div>
        <Router>
          <div     >
            <Link to={legacyBrickForm} target="_blank" className="downloadLink"  >
            <img className="downloadIcon" src={downloadIcon} alt=""></img> Legacy_Brick_Form.pdf
            </Link>
          </div>
        </Router>
      </div>
    }

  ></EventCard>
);

const eventCard2 = (
  <EventCard
    eventImage={bookSale1}
    title={"Book Sale"}
    information={
      <> 
      {bookSaleInfo}
      <br />
      <br />
                  <b>October 18, 2025</b> - 9:00am - 2:00pm Heritage Bank Parking Lot<br />

      <b>Febrauary 2025 </b>- LaSalle High School<br />
      </>
    }
    date={"October 2023"}
    width={"25%"}
    height={"auto"}
    startDate={"TBA"}
    endDate={"TBA"}
    startTime={"TBA"}
    endTime={"TBA"}
    location={"TBA"}
    
  ></EventCard>
);
const eventCard3 = (
  <EventCard
    eventImage={bookSale2}
    title={"Board Meeting"}
    information={
      "Held every second Thursday of the Month at Union Gap Library And Community Center"
    }
    date={"Every Second Thursday Of the Month"}
    width={"25%"}
    height={"auto"}
    startTime={"3:30pm"}
    endTime={"5:30pm"}
    location={"Union Gap Library And Community Center"}
  ></EventCard>
);
const eventCard4 = (
  <EventCard
    eventImage={jeans}
    title={"Dining for Dollars"}
    information={
      <>
      Each meal bought, in-house or to-go, donates $1 per meal to benefit the
      future Union Gap Library and Community Center.
      <br />
      <br /> 
      <b>Join Us for Thirst For Knowledge Thursdays!</b> Third Thursday of June, July and August 2025.

      <br /> 
      <br /> 
      <u>Upcoming Dining for Dollars in:</u><br /> 
      <b>April 2025</b> - Old Town Station<br /> 
      <b>May 2025 </b>- Jeans Cottage Inn<br /> 
      <b>August 2025 </b>- TBA<br /> 
      <b>September 2025 -TBA </b><br /> 
     <b>Donor Dinner October 9th, 2025</b>  - Union Gap Community Center<br/>
     <b>November 2025</b>  -TBA <br /> 
    </>
    }
    
    width={"25%"}
    height={"auto"}
   /* startDate={"TBA"}
    endDate={"TBA"}
    startTime={"TBA"}
    endTime={"TBA"}
    location={"TBA"}
    */
    content= {<div>
    <Router>
      <div     >
        <Link to={diningForDollars} target="_blank" className="downloadLink"  >
        <img className="downloadIcon" src={downloadIcon} alt=""></img> Dining for Dollars Info
        </Link>
      </div>
    </Router>
  </div>
    }
  ></EventCard>
);

const eventCard1Mobile = (
  <EventCard
    eventImage={legacyBricks}
    title={"Legacy Brick Fundraiser"}
    information={legacyBrickInfo}
    startDate={"Now"}
    endDate={"While Supplies Last"}
    width={"85%"}
    height={"auto"}
    endTime={"7"}
    startTime={"24"}
    content={
      <div>
        <Router>
          <div>
            <Link
              to={legacyBrickForm}
              target="_blank"
              className="downloadLink"
            >
                <img className="downloadIcon" src={downloadIcon} alt="download"></img> Legacy_Brick_Form.pdf
            </Link>
          </div>
        </Router>
      </div>
    }
    
  ></EventCard>
);

class events extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate(prevProps, prevState) {}
  componentDidMount() {}
  componentWillUnmount() {}

  render() {
    return (
      <div className="eventsParent">
        <div className="eventsContainer">
          <h1 className="eventsHeading">Events / Fundraisers</h1>
          {this.props.mobile && (
            <div className="eventCardContainerMobile">{eventCard1Mobile} </div>
          )}
          {!this.props.mobile && (
            <div className="eventCardContainer">
              {eventCard1} {eventCard2}   {eventCard3} {eventCard4}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default events;
